import React, { useState } from 'react';

function StudentPreview({ schoolDetails, formData, onEdit, handleInputChange, onSubmit, isSubmitting }) {
  const [error, setError] = useState('');

  const validateAndSubmit = (event) => {
    event.preventDefault();

    if (!formData.agreeTerms) {
      setError('Please provide consent before registering');
      return;
    }

    setError('');
    onSubmit();
  };

  return (
    <form className="student-card-body" onSubmit={validateAndSubmit}>
      <span className="student-section-title">REVIEW AND CONSENT</span>
      <p className="student-helper-text">Check every detail once before submitting the registration.</p>

      <div className="student-preview-section">
        <div className="student-preview-header">
          <span className="student-preview-title">SCHOOL DETAILS</span>
        </div>
        <div className="student-preview-grid">
          <div><strong>State:</strong> {schoolDetails.state}</div>
          <div><strong>District:</strong> {schoolDetails.district}</div>
          <div><strong>City:</strong> {schoolDetails.city}</div>
          <div><strong>School:</strong> {schoolDetails.school_name}</div>
        </div>
      </div>

      <div className="student-preview-section">
        <div className="student-preview-header">
          <span className="student-preview-title">STUDENT DETAILS</span>
          <button type="button" className="student-inline-button" onClick={onEdit}>
            Edit
          </button>
        </div>
        <div className="student-preview-grid">
          <div><strong>Name:</strong> {formData.student_name}</div>
          <div><strong>Phone:</strong> {formData.phone}</div>
          <div><strong>Gender:</strong> {formData.gender}</div>
          <div><strong>Grade:</strong> {formData.grade}</div>
          <div><strong>Language:</strong> {formData.language}</div>
        </div>
      </div>

      <label className="student-consent-row">
        <input
          type="checkbox"
          name="agreeTerms"
          checked={formData.agreeTerms}
          onChange={handleInputChange}
        />
        <span>I confirm the information is correct and consent to receive messages from TAP Buddy.</span>
      </label>

      {error && <span className="error">{error}</span>}

      <button type="submit" className="student-primary-button" disabled={isSubmitting}>
        <span className="student-primary-button-text">
          {isSubmitting ? 'REGISTERING...' : 'REGISTER'}
        </span>
      </button>
    </form>
  );
}

export default StudentPreview;
